import { proxy } from 'valtio';
import { LocalStorageService, STORAGE_KEYS } from '@/utils/local-storage';

export type UIState = {
  isLoading: boolean;
  showAddAccount: boolean;
  transactionIdForDetails?: string;
  reportIdForDetails?: string;
  isBalanceVisible: boolean;
};

// Load persisted balance visibility preference
const loadBalanceVisibility = (): boolean => {
  return LocalStorageService.get<boolean>(
    STORAGE_KEYS.BALANCE_VISIBILITY,
    true // Default to visible
  );
};

export const uiStateProxy = proxy<UIState>({
  isLoading: false,
  showAddAccount: false,
  isBalanceVisible: loadBalanceVisibility(),
});

export const uiStateActions = {
  setIsLoading: (isLoading: boolean) => {
    uiStateProxy.isLoading = isLoading;
  },
  setShowAddAccount: (showAddAccount: boolean) => {
    uiStateProxy.showAddAccount = showAddAccount;
  },
  closeAddAccount: () => {
    uiStateProxy.showAddAccount = false;
  },
  openAddAccount: () => {
    uiStateProxy.showAddAccount = true;
  },
  setTransactionIdForDetails: (transactionId?: string, reportId?: string) => {
    uiStateProxy.transactionIdForDetails = transactionId;
    uiStateProxy.reportIdForDetails = reportId;
  },
  toggleBalanceVisibility: () => {
    uiStateProxy.isBalanceVisible = !uiStateProxy.isBalanceVisible;
    // Persist balance visibility preference
    LocalStorageService.set(
      STORAGE_KEYS.BALANCE_VISIBILITY,
      uiStateProxy.isBalanceVisible
    );
  },
  setBalanceVisibility: (isVisible: boolean) => {
    uiStateProxy.isBalanceVisible = isVisible;
    // Persist balance visibility preference
    LocalStorageService.set(STORAGE_KEYS.BALANCE_VISIBILITY, isVisible);
  },
};
